import { render, staticRenderFns } from "./candidate-sign-in.vue?vue&type=template&id=39054f44&"
import script from "./candidate-sign-in.vue?vue&type=script&lang=js&"
export * from "./candidate-sign-in.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports